/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Configuration for detecting when new fields are created.
 * @export
 * @interface FieldCreatedEvent
 */
export interface FieldCreatedEvent {
    /**
     * If always, the integration will monitor for new fields by default.
     * @type {string}
     * @memberof FieldCreatedEvent
     */
    enabled: FieldCreatedEventEnabledEnum;
}


/**
 * @export
 */
export const FieldCreatedEventEnabledEnum = {
    Always: 'always'
} as const;
export type FieldCreatedEventEnabledEnum = typeof FieldCreatedEventEnabledEnum[keyof typeof FieldCreatedEventEnabledEnum];


/**
 * Check if a given object implements the FieldCreatedEvent interface.
 */
export function instanceOfFieldCreatedEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function FieldCreatedEventFromJSON(json: any): FieldCreatedEvent {
    return FieldCreatedEventFromJSONTyped(json, false);
}

export function FieldCreatedEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldCreatedEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function FieldCreatedEventToJSON(value?: FieldCreatedEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

